import { render, staticRenderFns } from "./InvoiceReceiveTypeIndex.vue?vue&type=template&id=10272c58&scoped=true&"
import script from "./InvoiceReceiveTypeIndex.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceiveTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10272c58",
  null
  
)

export default component.exports